import AttachmentOpenAction from '../schema/AttachmentOpenAction';
export default function getAttachmentDefaultOpenAction(strategy) {
    return ((strategy.supportedOpenActions.length && strategy.supportedOpenActions[0]) ||
        AttachmentOpenAction.NoAction);
}
//# sourceMappingURL=getAttachmentDefaultOpenAction.js.map